/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {FIREBASE_REPOSITORY_CONFIGURATION as ɵa} from './lib/configuration/firebase-repository.configuration';